import { render, staticRenderFns } from "./kr-search.vue?vue&type=template&id=32a04ede&scoped=true&"
import script from "./kr-search.vue?vue&type=script&lang=js&"
export * from "./kr-search.vue?vue&type=script&lang=js&"
import style0 from "./kr-search.vue?vue&type=style&index=0&id=32a04ede&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a04ede",
  null
  
)

export default component.exports